import type { FocusCategory } from '../../api/dashboardPublicApi';
import type { FocusReason } from '../../api/schemas/action-plan.schema';

export type FocusSignals = {
  hasLowScore: boolean;
  disagrees: boolean;
  /** Null when the backend sent no key, so the page shows the backend's own text instead */
  why: FocusReason | null;
};

const LOW_SCORE_REASONS: readonly FocusReason[] = ['lowScoreAndDisagreement', 'lowScore'];
const DISAGREEMENT_REASONS: readonly FocusReason[] = ['lowScoreAndDisagreement', 'disagreement'];

/**
 * The backend decides why the area was chosen (domain/survey/focus-reason.ts); the page only
 * words it in the language of the viewer and shows the matching signals.
 */
export const focusSignalsOf = ({ reasonKey }: Pick<FocusCategory, 'reasonKey'>): FocusSignals =>
  reasonKey
    ? {
        hasLowScore: LOW_SCORE_REASONS.includes(reasonKey),
        disagrees: DISAGREEMENT_REASONS.includes(reasonKey),
        why: reasonKey,
      }
    : { hasLowScore: false, disagrees: false, why: null };
